module.exports = __webpack_public_path__ + "img/PR15.d8d2f284.png";